<div class="container">
	<div class="image" [ngStyle]="{'background-image': 'url(' + article.image?.url + ')'}"><a (click)="goToArticle()"></a></div>
	<div class="info">
		<h3><a (click)="goToArticle()">{{article.articleName}}</a></h3>
		<p>{{article.excerpt}}</p>
		<a (click)="goToArticle()">Read More</a>
	</div>
	<div class="badge">News</div>
</div>
